import React from "react";
import { Box, Button, Dialog, DialogContent, FormLabel, IconButton, Link, Table, TableBody, TableCell, TablePagination, TableRow, TextareaAutosize, Toolbar, Tooltip, Typography } from "@material-ui/core";
import moment from "moment";
import { apiBatchRequest, apiDelete, apiPut, apiRequest } from "../../../utils/api_service";
import { API_HEADERS, API_URL, getSwaggerUrl } from "../../../constants/api";
import ConfirmDialog from "../../common/Dailogbox/ConfirmDailog";
import { SECTIONS, TOOLTIP_LABEL } from "../../../constants/appConstants";
import { IsSectionVisible, PaperComponent, getToolTipText } from "../../../utils/helper";
import { routes } from "../../../constants/routes";
import DeactivateImage from "../../../public/img/tenantuser/deactivate.svg"
import Back from "../../../public/img/tenantuser/back.svg"
import LightBulb from "../../../public/img/tenantuser/light-bulb.svg"
import Copy from "../../../public/img/tenantuser/copy-icon.svg"
import CopyToClipboard from "react-copy-to-clipboard";
import { ShowToast, toastType } from "../../../utils/toast-service";
import TextFieldWithToolTip from "../../common/TextFieldWithToolTip/TextFieldWithToolTip";
class ApiKeyManagement extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      apiHistory: [],
      tenantInfo: null,
      isOpenDeleteConfirmationPanel: false,
      tenantList: [],
      pageNo: 0,
      rowsPerPagination: 5,
      rowsPerPageOptions: [5, 10, 25, 50],
      apiToken: "",
      isDetailsPopup: false,
      toolTipData: [],
      isCancelDisable: false
    };
  }


  componentDidMount() {
    this.loadData()
  }

  /**
   * load required data
   */
  loadData = () => {
    apiBatchRequest([
      {
        url: API_URL.tenant.GetTenants,
        key: "tenants"
      },
      {
        url: API_URL.masterData.GetLabels,
        params: { sectionId: SECTIONS.API_KEY_MANAGEMENT },
        key: "toolTipData"
      }
    ]).then(({ tenants, toolTipData }) => {
      this.setState({
        tenantList: tenants.data || [],
        toolTipData: toolTipData.data || []

      }, () => {
        this.getAPIKeyHistory();
      });
    });
  };

  /**
   * Get history of tenant key 
   */
  getAPIKeyHistory = () => {
    const { tenantList } = this.state;
    const params = {
      tenantId: tenantList[0].ParentId,
      dateTimeOffset: moment().utcOffset()
    }
    apiRequest({
      url: API_URL.user.GetHistoryOfAPIKey,
      params
    }).then(({ data: apiHistory }) => {
      this.setState({
        apiHistory: apiHistory || []
      });
    });
  }

  /* **
   * generate api token
   * @param {*} params
   */
  generateApiToken = (params) => {

    apiPut({
      url: API_URL.tenant.GenerateApiToken,
      postBody: params
    }).then(({ data: response, success: success }) => {
      this.setState({
        apiToken: response.data.value,
        isDetailsPopupSubmitDisable: true,
        isCancelDisable: true
      }, () => {
        this.getAPIKeyHistory();
      })
    });
  };


  /* **
   * delete api token
   * @param {*} params
   */
  deleteApiToken = (params) => {
    apiDelete({
      url: API_URL.tenant.deleteApiToken +
        "?tenantId=" +
        params.tenantParentId +
        "&recordId=" +
        params.recordId
    }).then(({ data: response, success: success }) => {
      success == false
        ? ShowToast(
          "Server Error: Unable to delete Security Incident.",
          toastType.ERROR,
          5000,
          500
        )
        : ShowToast(
          "API Token has been deactivated successfully.",
          toastType.SUCCESS,
          5000,
          200
        );
      this.setState({
        isOpenDeleteConfirmationPanel: false,
        tenantInfo: null,
      }, () => {
        this.getAPIKeyHistory();
      })
    });
  };

  /**
   * click on submit key
   */
  clickOnGenerateAPIKeySubmit = () => {

    const { tenantList, textDescription } = this.state;
    if (textDescription !== undefined && textDescription.length !== 0 && textDescription.length<=100) {
      const param = {
        tenantInfo: tenantList[0].ParentId + "#" + tenantList[0].TenantDetailId + "#" + localStorage.getItem(API_HEADERS.AGI) + "#" + localStorage.getItem(API_HEADERS.CID) + "#" + tenantList[0].TenantId + "#" + new Date().getMilliseconds(),
        tenantId: tenantList[0].ParentId,
        aPIDescription: textDescription,
        statusId: 1
      }
      this.generateApiToken(param);
    }
    else {
      ShowToast("Description is Required and should be less than 100 characters.",
        toastType.ERROR,
        3001,
        2000
      );
    }
  }

  /** click on generate api key */
  clickOnGenerateAPIKey = () => {
    this.setState({
      isDetailsPopup: true,
      textDescription: ""
    });
  }

  /**
   * delete confirmation panel
   * @param {*} requestId
   */
  openDeleteConfirmationPanel = (isOpen, data) => {
    this.setState({
      tenantInfo: data,
      isOpenDeleteConfirmationPanel: isOpen
    });
  };


  /**
  * delete API key 
  * @param {*} res
  */
  deleteAPIKey = res => {
    if (res == true) {
      const { tenantInfo } = this.state;
      tenantInfo.statusId = 2;
      this.deleteApiToken(tenantInfo);
    } else {
      this.setState({
        isOpenDeleteConfirmationPanel: false,
        tenantInfo: null,
      });
    }
  };


  /** set / update page value */
  handleChangePage = (event, newPage) => {
    this.setState({ pageNo: newPage });
  };

  /** update row change values */
  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPagination: parseInt(event.target.value, 10), pageNo: 0 });
  };

  /**
   * view details on popup
   * @param {*} isDetailsPopup
   * @param {*} selectedData
   * @param {*} header
   * @param {*} data
   * @param {*} selectedId
   */
  viewData = (isDetailsPopup, apiToken = "") => {
    this.setState({
      isDetailsPopup: isDetailsPopup,
      apiToken,
      isDetailsPopupSubmitDisable:undefined,
      textDescription:""
    });
  };

  /**
   * Back to tenant page
   */
  backToTenant = () => {
    this.props.history.push({
      pathname: routes.tenants
    });
  }

  render() {
    const { apiHistory, isOpenDeleteConfirmationPanel,
      rowsPerPagination, pageNo, rowsPerPageOptions,
      apiToken, isDetailsPopup, toolTipData,
      textDescription, isDetailsPopupSubmitDisable, isCancelDisable } = this.state;
    return (
      <>

        <div
          className={"col-xs-12 col-sm-12 col-md-12 col-lg-12 pull-right end-xs back-button-align"}
          key={"container-action-back"}
        >
          <Tooltip
            title={
              getToolTipText(
                toolTipData,
                TOOLTIP_LABEL.BACK
              )
            }
          >
            <IconButton
              key={"container-action-IC-"}
              aria-label={"newWidget"}
              size={"small"}
              onClick={() => {
                this.backToTenant()
              }}
            >
              <img
                className={"back-icons"}
                src={Back}
                alt={"logo"}
              />
            </IconButton>
          </Tooltip>
        </div>
        <div className={"api-key-management"}>
          <ConfirmDialog
            size={"sm"}
            IsOpen={isOpenDeleteConfirmationPanel}
            Message={getToolTipText(
              toolTipData,
              TOOLTIP_LABEL.DEACTIVATE_MESSAGE
            )}
            OnHandelClick={this.deleteAPIKey}
            AgreeText={TOOLTIP_LABEL.YES}
            DisAgreeText={TOOLTIP_LABEL.NO}
          />
          <Dialog
            open={isDetailsPopup || false}
            PaperComponent={PaperComponent}
            fullWidth
          >

            <DialogContent>
              <div className={"row"}>
                <div className={"col-xs-8"}>
                  <TextFieldWithToolTip
                    id={"Description"}
                    txtName={"Description"}
                    value={textDescription || ""}
                    keyValue={"textDescription"}
                    onChange={(key, value) =>
                      this.setState({"textDescription": value})}
                    disabled={isDetailsPopupSubmitDisable || false}
                    isRequired
                    labelHeading={"Description"}
                    toolTip={getToolTipText(
                      toolTipData,
                      TOOLTIP_LABEL.DESCRIPTION
                    )}
                  />

                </div>
                <div className={"col-xs-2"}>
                  <Button
                    disabled={isCancelDisable || false}
                    className={"api-generate-api-key-btn"}
                    onClick={() => { this.viewData(false, []); }}
                  >
                    {"Cancel"}
                  </Button>
                </div>
                <div className={"col-xs-2"}>
                  <Button
                    className={"api-generate-api-key-btn"}
                    disabled={isDetailsPopupSubmitDisable || false}
                    onClick={() => { this.clickOnGenerateAPIKeySubmit() }}
                  >
                    {"Submit"}
                  </Button>
                </div>
              </div>
              {isDetailsPopupSubmitDisable &&
              <div className={"row"}>
                <div className={"col-xs-10 col-sm-10 col-md-10 col-lg-10 token-key"}>{apiToken}</div>
                <div className={"col-xs-2 col-sm-2 col-md-2 col-lg-2 pull-right end-xs"}>
                  <Tooltip
                    title={getToolTipText(
                      toolTipData,
                      TOOLTIP_LABEL.COPY
                    )}
                    placement={"bottom"}
                  >
                    <div className={"button-copy"}>
                      <CopyToClipboard text={apiToken} onCopy={() =>
                        { 
                          ShowToast(
                            "API Token has been copied successfully.",
                            toastType.SUCCESS,
                            5000,
                            200
                          );
                          this.setState({isCancelDisable: false})}}
                      >
                        <img
                          style={{
                            height: "28px",
                            width: "28px",
                            cursor: "pointer",
                            paddingRight: "8px",
                            paddingTop: "3px",
                          }}
                          src={Copy}
                          alt={"logo"}
                        />
                      </CopyToClipboard>
                    </div>
                  </Tooltip>
                </div>
              </div>}
            </DialogContent>
          </Dialog>

          <div className={"row margin-top-bottom "}>
            <div className={"col-xs-12"}>
              <Box color={"white"}
                bgcolor={"#07406d"} p={1}
                textAlign={"center"}
              >
                {"API Key Management\r"}
              </Box>
            </div>
          </div>
          <div className={"row"}>
            <div className={"col-xs-12 margin-top-bottom"}>
              <div className={" col-xs-12 col-sm-12 col-md-12 col-lg-12 api-key-management-note"}>
                <span>
                  <img
                    className={"light-icons"}
                    src={LightBulb}
                    alt={"logo"}
                  />

                  <span className={"api-key-note"}>
                    <i>
                      {getToolTipText(
                        toolTipData,
                        TOOLTIP_LABEL.API_NOTE
                      )}
                    </i>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div className={"row"}>
            <div className={"row col-xs-12 margin-top-bottom"}>
              {IsSectionVisible(
                SECTIONS.TENANT,
                SECTIONS.API_KEY_MANAGEMENT,
                SECTIONS.ADD_EDIT
              ) ?
                <div className={"col-xs-3 col-sm-3 col-md-3 col-lg-3 no-padding"}>
                  <Button
                    className={"api-generate-api-key-btn"}
                    onClick={this.clickOnGenerateAPIKey}
                  >
                    {"Generate API Key"}
                  </Button>
                </div> : ""}

              <div className={"col-xs-8 col-sm-8 col-md-8 col-lg-8 no-padding"} style={{ marginLeft: "15px", marginTop: "25px" }}>
                <Link
                  style={{ cursor: "pointer" }}
                  href={getSwaggerUrl()}
                  target={"_blank"}
                >
                  {getToolTipText(
                    toolTipData,
                    TOOLTIP_LABEL.API_INTERFACE
                  )}
                </Link>
                {": " + getToolTipText(
                  toolTipData,
                  TOOLTIP_LABEL.API_Doc
                )}
              </div>
            </div>
          </div>

          &nbsp;&nbsp;
          <div className={"row"}>
            <div className={"col-xs-12"}>
              <Box color={"white"}
                bgcolor={"#07406d"} p={1}
                textAlign={"center"}
              >
                {"History of Generated API Keys\r"}
              </Box>
            </div>
            <Table>
              <TableBody>
                {apiHistory && (apiHistory || []).length > 0 ?
                  ((
                    (rowsPerPagination > 0
                      ? apiHistory.slice(
                        pageNo * rowsPerPagination,
                        pageNo * rowsPerPagination + rowsPerPagination
                      )
                      : apiHistory) || []
                  ).map(api => {
                    return (<TableRow key={"row" + api.recordId + api.TenantParentId}>
                                <TableCell key={"cell-1" + api.recordId + api.TenantParentId}>
                                  <div className={"col-xs-12 col-md-12 col-lg-12"}>
                                    <b>{api.apiKeyName + "- " + api.apiDescription}</b>

                                    <FormLabel style={{ paddingTop: "10px" }} component={"legend"} className={"legend-text-label"} size={"small"} id={"createdOn"}>
                                      {"Created By :"}{" "}

                                      <Link href={"mailto:" + api.createdBy}>
                                        {api.createdBy}
                                      </Link> {" on "}
                                      {api.createdOn ? (
                                        moment(api.createdOn).format("MM/DD/YYYY hh:mm A")
                                      ) : null}
                                    </FormLabel>

                                    {api.deActivatedBy ?
                                      <FormLabel component={"legend"} className={"legend-text-label"} size={"small"} id={"createdOn"}>
                                        {"Deactivated By :"}{" "}

                                        <Link href={"mailto:" + api.deActivatedBy}>
                                          {api.deActivatedBy}
                                        </Link> {" on "}
                                        {api.deActivatedOn ? (
                                          moment(api.deActivatedOn).format("MM/DD/YYYY hh:mm A")
                                        ) : null}
                                      </FormLabel> : null}
                                  </div>
                                </TableCell>
                                <TableCell key={"cell-2" + api.recordId + api.TenantParentId} className={"deactivate-cell"} >
                                  {IsSectionVisible(
                                    SECTIONS.TENANT,
                                    SECTIONS.API_KEY_MANAGEMENT,
                                    SECTIONS.ADD_EDIT
                                  ) && api.statusDescription == "Active" ?
                                  <div className={"button-deactivate"}>
                                    <Tooltip
                                      title={getToolTipText(
                                        toolTipData,
                                        TOOLTIP_LABEL.DEACTIVATE
                                      )}
                                      placement={"bottom"}
                                    >
                                      <img
                                        className={"icons-deactivate"}
                                        src={DeactivateImage}
                                        alt={"logo"}
                                        onClick={() => {
                                          this.openDeleteConfirmationPanel(
                                            true,
                                            api
                                          )
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                    : ""}
                                </TableCell>
                                
                            </TableRow>)
                  }))
                  :
                  (
                    <TableRow>
                      <TableCell style={{ textAlign: "center" }} colSpan={2}>
                        {"No data available\r"}
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          
            {apiHistory && apiHistory.length > 0 && (
              <div className={"row MuiTable-root"}>
                <div className={"xs-end"}>
                  <div className={"paginationContainer"}>
                    <TablePagination
                      rowsPerPageOptions={rowsPerPageOptions}
                      component={"div"}
                      count={apiHistory?.length}
                      rowsPerPage={rowsPerPagination}
                      page={pageNo}
                      onPageChange={this.handleChangePage}
                      onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

      </>
    )
  }
}
export default ApiKeyManagement;
